"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * This API allows 3rd party developers to translate item title, description, search query.
 */
class Translation extends __1.default {
    get basePath() {
        return '/commerce/translation/v1_beta';
    }
    /**
     * Translates input text inot a given language.
     *
     * @param body TranslateRequest
     */
    translate(body) {
        return this.post(`/translate`, body);
    }
}
exports.default = Translation;
Translation.id = 'Translation';
//# sourceMappingURL=index.js.map